"use client"

import { OrdersPagination } from "@/components/sections"
import { SellerReview } from "../SellerReview/SellerReview"
import { useSearchParams } from "next/navigation"
import { useTranslate } from "@tolgee/react"

const LIMIT = 10

export const SellerReviewList = ({ reviews }: { reviews?: any[] }) => {
  const { t } = useTranslate()
  const searchParams = useSearchParams()
  const page = searchParams.get("page") || 1

  const pages = Math.ceil((reviews?.length || 0) / LIMIT) || 1

  const filteredReviews = reviews?.slice((+page - 1) * LIMIT, +page * LIMIT)

  if (!reviews?.length) {
    return (
      <div className="flex items-center justify-center min-h-[160px] py-16 px-6 text-[14px] text-[#717182] tracking-[-0.15px]">
        {t("product_review.reviews_empty")}
      </div>
    )
  }

  return (
    <div className="mt-4">
      {filteredReviews?.map((review) => (
        <SellerReview key={review.id} review={review} />
      ))}

      {pages > 1 && <OrdersPagination pages={pages} />}
    </div>
  )
}
